<template>
    <div class="x_box">
        <ol class="breadcrumb x_breadcrumb">
            <li class="breadcrumb-item active" aria-current="page">{{$t('stock_on_hand_list')}}</li>
        </ol>
        <div class="x_header">
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="$router.go(-1)"><i class="fa fa-arrow-circle-o-left"></i> {{ $t('back') }}</button>
            <router-link to="/stock/onhand" class="btn btn-outline-primary btn-sm no-bor"><i class="fa fa-plus-circle"></i> {{$t('new')}}</router-link>
            <button type="button" class="btn btn-outline-primary btn-sm no-bor" @click="print">
                <i class="fa fa-print"></i>
                {{$t('print')}}
            </button>
            <div class="pull-right">
                <input type="text" class="form-control form-control-sm" :placeholder="$t('search')" v-model="query.Text" @keypress.enter="toList" />
            </div>
        </div>
        <div class="x_body">
            <div class="card x_card">
                <div class="card-body">
                    <div class="row-flex-x">
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('branch')}}</label>
                                <select class="form-control form-control-sm" v-model="query.BranchId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in branches" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('category')}}</label>
                                <select class="form-control form-control-sm" v-model="query.CategoryId" @change="toList">
                                    <option value="">{{$t('all')}}</option>
                                    <option v-for="ret in categories" :value="ret.Id" :key="ret.Id">{{ret.Name}}</option>
                                </select>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">{{$t('item')}}</label>
                                <AuthCompleted @select="onSelect" :place="$t('all')" :is-include-all="true" dropdown-width='200%'></AuthCompleted>
                            </div>
                        </div>
                        <div>
                            <div class="form-group">
                                <label class="label-control blue">&nbsp;</label>
                                <div>
                                    <button type="button" class="btn btn-default btn-sm" @click="toList"><i aria-hidden="true" class="fa fa-search"></i> {{$t('search')}}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <table class="table table-bordered table-sm table-striped no-bor">
                        <thead>
                            <tr class="toUpper">
                                <th>{{ $t('no') }}</th>
                                <th>{{ $t('code') }}</th>
                                <th>{{ $t('name') }}</th>
                                <th>{{ $t('category') }}</th>
                                <th>{{ $t('branch')}}</th>
                                <th class="text-right">{{ $t('begin_stock')}}</th>
                                <th class="text-right">{{ $t('stock_in')}}</th>
                                <th class="text-right">{{ $t('qty_transfer_in')}}</th>
                                <th class="text-right">{{ $t('stock_out')}}</th>
                                <th class="text-right">{{ $t('qty_transfer_out')}}</th>
                                <th class="text-right">{{ $t('end_stock') }}</th>
                                <th>{{$t('uom')}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(ret, index) in list" :key="index">
                                <td>{{index+1}}</td>
                                <td>{{ret.ItemCode}}</td>
                                <td>{{ret.ItemName}}</td>
                                <td>{{ret.Category}}</td>
                                <td>{{ret.BranchName}}</td>
                                <td class="text-right">{{$number(ret.BeginStock, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.StockInQty, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.TransferInQty, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.StockOutQty, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.TransferOutQty, '0,0.00')}}</td>
                                <td class="text-right">{{$number(ret.Quantity, '0,0.00')}}</td>
                                <td>{{ret.UomName}}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { AuthCompleted } from '../Item';
    export default {
        components: {
            AuthCompleted,
        },
        data() {
            return {
                query: {
                    Text: '',
                    BranchId: '',
                    ItemId: '',
                    CategoryId: '',
                    CompanyId: this.$store.state.company.Id
                },
                categories: [],
                list: [],
                branches: []
            }
        },
        created() {
            this.branchList();
            this.getItemCategory();
            this.toList();
        },
        methods: {
            toList() {
                var loading = this.$loading.show();
                this.$api().post('stockonhand', this.query).then(res => {
                    if (this.$isValid(res)) {
                        this.list = res.data.Data;
                    }
                }).finally(() => { loading.hide(); });
            },
            onSelect(e) {
                if (e == null) this.query.ItemId = '';
                else this.query.ItemId = e.Id;
                this.toList();
            },
            getItemCategory: function () {
                var loading = this.$loading.show();
                this.$api().post('category/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.categories = res.data.Json.Categories;
                    }
                }).finally(function () { loading.hide(); });
            },
            branchList() {
                var loading = this.$loading.show();
                this.$api().post('branch/list', { CompanyId: this.$store.state.company.Id }).then(res => {
                    if (this.$isValid(res)) {
                        this.branches = res.data.Json.Branches;
                    }
                }).finally(() => { loading.hide(); });
            },
            print() {
                let link = '/print/stock/onhand?';
                if (this.query.BranchId != '') link = link + 'branchid=' + this.query.BranchId;
                window.open(link, '_blank');
            }
        }
    }
</script>
